import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { EventService } from "assets/app/services/event-service";
import { AclService } from "../../services/acl-service";

enum BulkEditMode {
    Regular = 0,
    Column = 1,
    RecordTitles = 2,
    AllRecordTitles = 3
}

enum BulkAssociationMode {
    Replace = 0,
    Add = 1,
    Remove = 2
}


export class BulkEditModalController {
    static $inject = ["$q", "$uibModalInstance", "notifyService", "entityService", "entityConfigService", "$window",
        "parentEntityID", "groupedEntityCharDataCollections", "divID", "charTypeID", "templateID",
        "recordParentRelationships", "parentCurrencyCharData", "relationshipTitles", "isBulkCreateMode", "recordChildRelationships", "relatedChildChartypeIDs",
        "sortField", "sortDir", "entityRelRecIDs", "configuredRelatedCharTypeIDs", "eventService", "aclService"];

    public entitiesToCatalog: { [entityId: string]: Models.IEntityIdAndTitle[] } = {};
    firstGroupEntity: Models.ICharDataCollection;
    groupEntities: { [entitiyID: string]: Models.ICharDataCollection };
    selectedBulkEntityCharDataCollections: Models.ICharDataCollection[];
    originalCopyOfGroupedBulkEntityCharDataCollections: { [entityID: string]: Models.ICharDataCollection[] };
    visibility: number;
    showBulkEdit: boolean;
    entityCurrencyCharDatas: { [entityID: string]: Models.ICharDataValue };
    selectedRecIds: number[];
    showEditColumnDatasModal: boolean;
    selectedBulkEditColumnEntityCharData: Models.ICharDataCollection;
    bulkEditColumnCharDatas: { [key: string]: Models.ICharDataValue[] };
    bulkEditColumTagLabel: string;
    loadingData: boolean;
    forceRefresh: boolean;
    hasRelationshipTitles: boolean;
    bulkCreateCharDatas: ({ [tagLabel: string]: string } | {})[];
    showTagLabels: { [templateID: string]: string[] };

    // Pagers
    startPageRecord: { [entityID: string]: number } = {};
    endPageRecord: { [entityID: string]: number } = {};
    searchNumFound: { [entityID: string]: number } = {};
    searchPage: { [entityID: string]: number } = {};
    searchPageCount: { [entityID: string]: number } = {};
    searchPageSize: { [entityID: string]: number } = {};
    //--
    selectedBulkEditCharacteristics: Models.ICharacteristicMetaData[];
    selectedBulkEditOption: number;
    showSelectCharacteristicForBulkEdit: boolean;
    showBulkEditForSelectedOption: boolean;
    showBulkEditSelectOption: boolean;
    selectedBulkEditMode: BulkEditMode = BulkEditMode.Regular;
    childEntityRelationships: Models.IEntityRelationship[];
    relationshipCharTypeID: number;
    selectedEntities: Models.IEntitySearchDoc[];
    recordID: number;
    recRelsEntityID: string;
    bulkRecordAssociationMode: BulkAssociationMode = BulkAssociationMode.Replace;
    charTypeNames: { [id: number]: string };
    addRelationships: { [chartypeID: number]: { [entityID: string]: string[] } };
    removeRelationships: { [charTypeID: number]: string[] };
    originalRecordChildRelationships: { [entityID: string]: Models.IEntityRelationship[] };
    title: string;
    editColumnParentEntityID: string;
    showParents: boolean = false;
    singleSelect: boolean = false;
    searchByEntityID: string;
    relationshipsRequired: _.Dictionary<boolean> = {};
    disabled = false;

    constructor(
        private $q: ng.IQService,
        private $uibModal: ng.ui.bootstrap.IModalServiceInstance,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        private $window: ng.IWindowService,
        private parentEntityID: string,
        private groupedEntityCharDataCollections: { [entityID: string]: Models.ICharDataCollection[] },
        private divID: number,
        private charTypeID: number,
        private templateID: number,
        private recordParentRelationships: Models.IEntityRelationship[],
        private parentCurrencyCharData: Models.ICharDataValue,
        private relationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; },
        private isBulkCreateMode: boolean,
        private recordChildRelationships: { [entityID: string]: Models.IEntityRelationship[] },
        private relatedChildChartypeIDs: number[],
        private sortField: string,
        private sortDir: number,
        private entityRelRecIDs: { [entityID: string]: string },
        private configuredRelatedCharTypeIDs: { [charTypeID: number]: boolean },
        private eventService: EventService,
        private aclService: AclService) {

        this.selectedBulkEditCharacteristics = [];
        this.visibility = 1;
        this.bulkEditColumnCharDatas = {};
        this.entityCurrencyCharDatas = {};
        this.addRelationships = {};
        this.removeRelationships = {};
        this.originalRecordChildRelationships = {};
        this.childEntityRelationships = [];
        this.charTypeNames = <{ [id: number]: string }>Consts.CharTypeNames.IDs;
        this.searchByEntityID = "";

        if (this.relationshipTitles != null) {
            this.hasRelationshipTitles = true;
        }
        else {
            this.hasRelationshipTitles = false;
        }

        if (!this.isBulkCreateMode) {
            this.setupBulkEditOption();
        }
        else {
            this.title = "Bulk Create Records";
            this.selectedBulkEditOption = 1;
            this.showSelectCharacteristicForBulkEdit = false;
            this.showBulkEditSelectOption = false;
            this.selectedBulkEditCharacteristics = [];
            this.setupBulkEdit();
        }

        if (this.charTypeID == Consts.CharTypeIDs.amount) {
            this.showParents = true;
            this.singleSelect = true;
        }

        if (!_.isEmpty(this.relatedChildChartypeIDs)) {
            _.forEach(this.relatedChildChartypeIDs, (charTypeID) => {
                this.getRelationshipsRequired(this.charTypeID, templateID, charTypeID);
            });
        }
    }

    private setupBulkEdit() {

        this.showTagLabels = {};
        if (!this.parentEntityID || !this.groupedEntityCharDataCollections) {
            throw new Error("Must specify both a ParentEntityID and SelectedBulkEntityCharDataCollections");
        }

        this.showBulkEditSelectOption = false;
        const bulkEditRows = Object.keys(this.groupedEntityCharDataCollections).length;

        if (this.originalCopyOfGroupedBulkEntityCharDataCollections == undefined) {
            this.originalCopyOfGroupedBulkEntityCharDataCollections = _.cloneDeep(this.groupedEntityCharDataCollections);
        }
        this.entityCurrencyCharDatas = {};
        this.groupEntities = {};


        for (let groupEntityID in this.groupedEntityCharDataCollections) {
            if (this.groupedEntityCharDataCollections[groupEntityID].length > 0) {

                if (this.showParents) {
                    this.entityService.getEntityCharData(groupEntityID)
                        .then((res) => {
                            if (!this.firstGroupEntity) {
                                this.firstGroupEntity = res;
                            }

                            if (this.selectedBulkEditCharacteristics.length > 0) {
                                var entityCharDatas = _.cloneDeep(this.firstGroupEntity.charDatas);
                                var selectedEntityCharDatas: Models.ICharDatas = {};
                                _.forEach(this.selectedBulkEditCharacteristics, (schr) => {
                                    var charDatas = entityCharDatas[schr.tagLabel];
                                    selectedEntityCharDatas[schr.tagLabel] = charDatas;
                                });
                                this.firstGroupEntity.charDatas = selectedEntityCharDatas;
                                this.firstGroupEntity.templateMetaData.characteristicMetaDatas = this.selectedBulkEditCharacteristics;
                                res.charDatas = selectedEntityCharDatas;
                                res.templateMetaData.characteristicMetaDatas = this.selectedBulkEditCharacteristics;
                            }
                            this.groupEntities[groupEntityID] = res;
                        });
                }

                var pageSize = _.isEmpty(this.searchPageSize) ? 10 : this.searchPageSize[groupEntityID];

                this.setupPager(groupEntityID, bulkEditRows > 2 ? 5 : pageSize, this.groupedEntityCharDataCollections[groupEntityID]);

                _.forEach(this.groupedEntityCharDataCollections[groupEntityID], (charDataCollection) => {
                    if (this.isBulkCreateMode) {
                        _.remove((charDataCollection.templateMetaData.characteristicMetaDatas), (cmd) => {
                            var targetAcl = Utils.AclUtil.getDataEntityAcl(charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.template.templateGroupID, charDataCollection.templateMetaData.templateID, cmd.groupID, cmd.characteristicID);
                            return !Utils.AclUtil.hasAccess(this.aclService.acls, targetAcl, Consts.AccessRight.Create);
                        });

                        _.remove(charDataCollection.templateMetaData.characteristicMetaDatas, cmd => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file);
                    }

                    if (this.selectedBulkEditCharacteristics.length > 0) {
                        var entityCharDatas = _.cloneDeep(charDataCollection.charDatas);
                        var selectedEntityCharDatas: Models.ICharDatas = {};
                        _.forEach(this.selectedBulkEditCharacteristics, (schr) => {
                            var charDatas = entityCharDatas[schr.tagLabel];
                            selectedEntityCharDatas[schr.tagLabel] = charDatas;
                        });
                        charDataCollection.charDatas = selectedEntityCharDatas;
                        charDataCollection.templateMetaData.characteristicMetaDatas = this.selectedBulkEditCharacteristics;
                    }
                    const entityCurrencyCharData = Utils.CharUtil.GetCurrencyCharData(charDataCollection) || this.parentCurrencyCharData;
                    this.entityCurrencyCharDatas[charDataCollection.entityID] = entityCurrencyCharData;
                });

                this.setupTagLabels(this.groupedEntityCharDataCollections[groupEntityID][0].templateMetaData);
            }
        }

        this.showBulkEditForSelectedOption = true;
    }

    private setupBulkEditOption() {
        this.showBulkEditSelectOption = true;
        this.selectedBulkEditOption = 1;
        this.showSelectCharacteristicForBulkEdit = false;
        this.showBulkEditForSelectedOption = false;
        this.title = "Select Bulk Edit Option";
    }

    public SelectBulkEditOption() {
        if (this.selectedBulkEditOption == 2) {
            this.title = "Select Characteristics to Bulk Edit";
            this.showSelectCharacteristicForBulkEdit = true;
            this.showBulkEditSelectOption = false;
        }
        else {
            this.title = "Bulk Edit Records";
            this.showSelectCharacteristicForBulkEdit = false;
            this.showBulkEditSelectOption = false;
            this.selectedBulkEditCharacteristics = [];
            this.setupBulkEdit();
        }
    }

    public CharacteristicsSelected(characteristics: Models.ICharacteristicMetaData[]) {
        this.showBulkEditSelectOption = false;
        this.showSelectCharacteristicForBulkEdit = false;
        this.selectedBulkEditCharacteristics = characteristics;
        this.setupBulkEdit();
    }

    public Cancel() {
        this.$uibModal.dismiss();
    }

    private setupPager(parentEntityID: string, pageSize: number, charDataCollections: Models.ICharDataCollection[]): void {
        this.searchPage[parentEntityID] = 1;
        this.searchPageSize[parentEntityID] = pageSize || 10;
        this.searchPageCount[parentEntityID] = Math.ceil(charDataCollections.length / this.searchPageSize[parentEntityID]) || 1;
        this.searchNumFound[parentEntityID] = charDataCollections.length;
        this.startPageRecord[parentEntityID] = (this.searchPage[parentEntityID] - 1) * this.searchPageSize[parentEntityID];
        this.endPageRecord[parentEntityID] = this.startPageRecord[parentEntityID] + this.searchPageSize[parentEntityID];
    }

    private setupTagLabels(templateMetaData: Models.ICharacteristicMetaDataCollection): void {
        var sortedGroups = _.sortBy(templateMetaData.groups, (grp) => grp.sequenceNumber);
        this.showTagLabels[templateMetaData.templateID.toString()] = [];
        _.forEach(sortedGroups, (group) => {
            var groupID = group.groupID;
            var groupCMDs = _(templateMetaData.characteristicMetaDatas)
                .filter((cmd) => {
                    return (cmd.groupID == groupID || groupID == -1)
                })
                .sortBy((cmd) => cmd.sequenceNumber)
                .valueOf();

            _.forEach(groupCMDs, (grpCMD) => {
                if (this.selectedBulkEditCharacteristics.length > 0) {
                    if (_.any(this.selectedBulkEditCharacteristics, schr => schr.tagLabel == grpCMD.tagLabel)) {
                        this.showTagLabels[templateMetaData.templateID.toString()].push(grpCMD.tagLabel);
                    }
                }
                else {
                    this.showTagLabels[templateMetaData.templateID.toString()].push(grpCMD.tagLabel);
                }
            });
        });
    }

    public SaveBulkEdit(isValid: boolean) {
        if (isValid) {
            let bulkEntityCharDatas: Models.IBulkEntityRelationships[] = [];
            let isCreate = false;
            var cleanedAddRelationships: { [entityID: string]: string[] } = {};
            var removeRelationships: string[] = [];
            var selectedCharIDs: number[] = [];
            var validationMessage = "";
            var requiredButMissingRelationshipsRequired: _.Dictionary<boolean> = {};

            if (!_.isEmpty(this.relationshipsRequired)) {
                for (let groupEntityID in this.groupedEntityCharDataCollections) {
                    let cdcs = this.groupedEntityCharDataCollections[groupEntityID];
                    _.forEach(cdcs, (u) => {
                        for (var key in this.relationshipsRequired) {
                            if (this.relationshipsRequired[key]) {
                                if (this.relationshipTitles[u.entityID]) {
                                    var recIDAndTitles = this.relationshipTitles[u.entityID][key];
                                    if (_.isEmpty(recIDAndTitles)) {
                                        requiredButMissingRelationshipsRequired[key] = true;
                                    }
                                }
                                else {
                                    requiredButMissingRelationshipsRequired[key] = true;
                                }
                            }
                        }
                    });
                }
            }

            if (!_.isEmpty(requiredButMissingRelationshipsRequired)) {
                for (var key in requiredButMissingRelationshipsRequired) {
                    var missingCharTypeID = _.parseInt(key);
                    if (requiredButMissingRelationshipsRequired[key]) {
                        if (missingCharTypeID == Consts.CharTypeIDs.property) {
                            validationMessage = validationMessage + "Required Catalog Item association must be selected for all records. \n";
                        }

                        if (missingCharTypeID == Consts.CharTypeIDs.user) {
                            validationMessage = validationMessage + "Required Contact association must be selected for all records. \n";
                        }

                        if (missingCharTypeID == Consts.CharTypeIDs.project) {
                            validationMessage = validationMessage + "Required Project association must be selected for all records. \n";
                        }
                    }
                }
            }

            if (!_.isEmpty(validationMessage)) {
                this.disabled = false;
                alert(validationMessage);
            }
            else {
                _.forEach(this.relatedChildChartypeIDs, (r) => {
                    for (let relEntityID in this.addRelationships[r]) {
                        if (cleanedAddRelationships[relEntityID] == undefined) {
                            cleanedAddRelationships[relEntityID] = [];
                        }
                        cleanedAddRelationships[relEntityID] = _.union(cleanedAddRelationships[relEntityID], this.addRelationships[r][relEntityID]);
                    }

                    var removeRelForCharType = this.removeRelationships[r];
                    if (removeRelForCharType != undefined) {
                        removeRelationships = removeRelationships.concat(removeRelForCharType);
                    }
                });

                if (removeRelationships.length > 0) {
                    _.forEach(removeRelationships, (rr) => {
                        var chdRecID = Utils.IdBuilder.splitEntityID(rr);
                        if (chdRecID.recID == 0) {
                            _.remove(removeRelationships, r => r == rr);
                        }
                    });
                }

                for (let groupEntityID in this.groupedEntityCharDataCollections) {
                    let cdcs = this.groupedEntityCharDataCollections[groupEntityID];

                    _.forEach(cdcs, (u) => {
                        var split = Utils.IdBuilder.splitEntityID(u.entityID);
                        var relationships: { [charTypeID: number]: number[] } = {};

                        if (this.hasRelationshipTitles && this.isBulkCreateMode) {
                            if (this.relationshipTitles[u.entityID]) {
                                _.forEach(this.relatedChildChartypeIDs, (relCharTypeID) => {
                                    var recIDAndTitles = this.relationshipTitles[u.entityID][relCharTypeID];
                                    let recIDs: number[] = [];
                                    _.forEach(recIDAndTitles, (rec) => {
                                        recIDs.push(rec.recID);
                                    });

                                    if (recIDs.length > 0) {
                                        relationships[relCharTypeID] = recIDs;
                                    }
                                });
                            }
                        }

                        if (split.recID <= 0) {
                            u.entityID = Utils.IdBuilder.buildEntityID(split.divID, split.charTypeID, 0);
                            isCreate = true;
                        }

                        var entityCharData: Models.IBulkEntityCharData;
                        entityCharData = { entityID: u.entityID, charDatas: u.charDatas };

                        var bulkEditEntityCharData: Models.IBulkEntityRelationships = {
                            parentEntityID: groupEntityID,
                            entityCharData: entityCharData,
                            templateID: u.templateMetaData.templateID,
                            relationships: isCreate ? relationships : undefined
                        };
                        bulkEntityCharDatas.push(bulkEditEntityCharData);
                    });
                }

                if (this.selectedBulkEditCharacteristics.length > 0) {
                    selectedCharIDs = this.selectedBulkEditCharacteristics.map(chr => chr.characteristicID);
                }

                this.notifyService.startProgress();
                this.entityService.saveBulkEditCharData(this.parentEntityID, this.charTypeID, this.templateID, bulkEntityCharDatas, this.isBulkCreateMode, removeRelationships, cleanedAddRelationships, selectedCharIDs)
                    .then((result) => {
                        this.notifyService.endProgress();
                        this.showBulkEdit = false;
                        this.$uibModal.close(result);
                    });
            }
        }
    }

    public EditAllRelationshipTitles(charTypeID: number, parentEntityID: string) {
        this.selectedBulkEditMode = BulkEditMode.AllRecordTitles;
        this.childEntityRelationships = [];
        this.relationshipCharTypeID = charTypeID;
        this.searchByEntityID = "";

        if (this.charTypeID != Consts.CharTypeIDs.amount) {
            for (let entityID in this.recordChildRelationships) {
                this.childEntityRelationships = this.childEntityRelationships.concat(_.filter(this.recordChildRelationships[entityID], r => r.childCharTypeID == this.relationshipCharTypeID));
            }
            this.searchByEntityID = parentEntityID;
        }
        else {
            this.searchByEntityID = this.entityRelRecIDs[parentEntityID];
        }

        this.selectedEntities = [];
    }

    public EditRecordRelationshipTitles(entityID: string, charTypeID: number) {
        this.recRelsEntityID = entityID;
        this.selectedBulkEditMode = BulkEditMode.RecordTitles;
        this.relationshipCharTypeID = charTypeID;
        this.childEntityRelationships = _.filter(this.recordChildRelationships[entityID], r => r.childCharTypeID == this.relationshipCharTypeID);
        this.searchByEntityID = "";
        this.recordID = Utils.IdBuilder.splitEntityID(entityID).recID;

        if (this.charTypeID != Consts.CharTypeIDs.amount) {
            this.searchByEntityID = this.parentEntityID;
        }
        else {
            for (let usageEntityID in this.groupedEntityCharDataCollections) {
                if (_.any(this.groupedEntityCharDataCollections[usageEntityID], u => u.entityID == entityID)) {
                    this.searchByEntityID = this.entityRelRecIDs[usageEntityID];
                    break;
                }
            }
        }
        this.selectedEntities = [];
    }

    public CancelBulkColumnEdit() {
        this.searchByEntityID = "";
        this.selectedBulkEditColumnEntityCharData = null;
        this.showEditColumnDatasModal = false;
        this.selectedBulkEditMode = BulkEditMode.Regular;
    }

    public EditColumnDatas(parentEntityID: string, characteristicID: number) {
        this.editColumnParentEntityID = parentEntityID;
        this.showEditColumnDatasModal = true;
        this.selectedBulkEditMode = BulkEditMode.Column;

        var cdcs = this.groupedEntityCharDataCollections[parentEntityID];

        var filteredTempalteMetaData: Models.ICharacteristicMetaDataCollection = _.cloneDeep(cdcs[0].templateMetaData);
        var filteredTemplateCharacteristicMetaDatas: Array<Models.ICharacteristicMetaData> = [];
        var bulkEditColumnMetaData = _.find(filteredTempalteMetaData.characteristicMetaDatas, (cmd) => cmd.characteristicID == characteristicID);
        var entityID = Utils.IdBuilder.buildEntityID(0, this.charTypeID, -1);

        var charDataValue: Models.ICharDataValue = {
            charID: characteristicID,
            value: null,
            recCharID: 0,
        };

        var charDataValues: Models.ICharDataValue[] = [charDataValue];
        this.bulkEditColumTagLabel = bulkEditColumnMetaData.tagLabel;
        this.bulkEditColumnCharDatas[this.bulkEditColumTagLabel] = charDataValues;
        filteredTemplateCharacteristicMetaDatas.push(bulkEditColumnMetaData);
        filteredTempalteMetaData.characteristicMetaDatas = filteredTemplateCharacteristicMetaDatas;

        this.selectedBulkEditColumnEntityCharData = {
            charDatas: this.bulkEditColumnCharDatas,
            entityID: entityID,
            status: null,
            templateMetaData: filteredTempalteMetaData
        };
    }

    public canEdit(cmd: Models.ICharacteristicMetaData): boolean {
        return Utils.AclUtil.hasAccess(this.aclService.acls, cmd.acl, Consts.AccessRight.Write);
    }

    public SaveBulkEditColumnData(isValid: boolean) {
        let cdcs = this.groupedEntityCharDataCollections[this.editColumnParentEntityID];
        let cmd = this.selectedBulkEditColumnEntityCharData.templateMetaData.characteristicMetaDatas.find(chr => chr.tagLabel == this.bulkEditColumTagLabel);

        _.forEach(cdcs, (c) => {
            var bulkEditedColumnCharDatas = _.cloneDeep(this.selectedBulkEditColumnEntityCharData.charDatas[this.bulkEditColumTagLabel]);
            if (cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date) {
                if (c.charDatas[this.bulkEditColumTagLabel].length > 0 && c.charDatas[this.bulkEditColumTagLabel].length == 1) {
                    c.charDatas[this.bulkEditColumTagLabel][0].value = bulkEditedColumnCharDatas[0].value;
                }
                else {
                    c.charDatas[this.bulkEditColumTagLabel] = bulkEditedColumnCharDatas;
                }
            }
            else {
                c.charDatas[this.bulkEditColumTagLabel] = bulkEditedColumnCharDatas;
            }
        });

        this.showEditColumnDatasModal = false;
        this.selectedBulkEditColumnEntityCharData = null;
        this.bulkEditColumnCharDatas = {};
        this.bulkEditColumTagLabel = "";
        this.selectedBulkEditMode = BulkEditMode.Regular;
    }

    public SaveSelectedRelationshipsRecordsForAll() {
        let selectedEntitiesLength = this.selectedEntities.length;
        var confirmMessage = `Are you sure you want to ${BulkAssociationMode[this.bulkRecordAssociationMode]} ${selectedEntitiesLength} ${this.charTypeNames[this.relationshipCharTypeID]}s for ${this.charTypeNames[this.charTypeID]} Records?`;
        if (this.$window.confirm(confirmMessage)) {

            if (this.addRelationships[this.relationshipCharTypeID] == undefined) {
                this.addRelationships[this.relationshipCharTypeID] = {};
            }

            var removeRelationshipIDs: string[] = this.removeRelationships[this.relationshipCharTypeID];
            if (removeRelationshipIDs == undefined) {
                removeRelationshipIDs = [];
            }

            var parentEntityID = "";
            if (this.charTypeID == Consts.CharTypeIDs.amount) {
                for (let entityID in this.entityRelRecIDs) {
                    if (this.entityRelRecIDs[entityID] == this.searchByEntityID) {
                        parentEntityID = entityID;
                    }
                }
            }
            else {
                parentEntityID = this.parentEntityID;
            }

            let cdcs = this.groupedEntityCharDataCollections[parentEntityID];

            _.forEach(cdcs, (u) => {
                var split = Utils.IdBuilder.splitEntityID(u.entityID);
                var recordChildRels = _.filter(this.recordChildRelationships[u.entityID], r => r.childCharTypeID == this.relationshipCharTypeID);
                var recordChildTitles: Models.IEntityRecIDTitle[] = [];

                if (this.relationshipTitles[u.entityID] != undefined) {
                    recordChildTitles = this.relationshipTitles[u.entityID][this.relationshipCharTypeID];
                }

                if (this.bulkRecordAssociationMode == BulkAssociationMode.Add) {

                    if (this.charTypeID == Consts.CharTypeIDs.amount) {
                        recordChildTitles = [];
                        _.forEach(recordChildRels, (childRel) => {
                            removeRelationshipIDs.push(Utils.IdBuilder.buildRelationshipID(childRel));
                        });
                    }

                    _.forEach(this.selectedEntities, (se) => {
                        if (!_.any(recordChildRels, rc => rc.childRecID == se.recordID)) {

                            var recordChildTitle: Models.IEntityRecIDTitle = {
                                recID: se.recordID,
                                title: se.title
                            };
                            recordChildTitles.push(recordChildTitle);

                            var fakeRecChilRel: Models.IEntityRelationship = {
                                divisionID: split.divID,
                                parentRecID: 0,
                                parentCharTypeID: 0,
                                childCharTypeID: this.relationshipCharTypeID,
                                childRecID: se.recordID,
                                level: 0,
                                relRecID: 0,
                                relTypeID: 1,
                                relIndicatorID: 0,
                                sequenceNumber: 0
                            };
                            recordChildRels.push(fakeRecChilRel);
                        }
                    });
                    this.relationshipTitles[u.entityID][this.relationshipCharTypeID] = recordChildTitles;
                    var recParentRel = _.find(this.recordParentRelationships, r => r.childRecID == split.recID);
                    this.addRelationships[this.relationshipCharTypeID][Utils.IdBuilder.buildRelationshipID(recParentRel)] = this.selectedEntities.map((ae) => { return ae.entityID; });
                    var notRelCharTypeIDRels = _.filter(this.recordChildRelationships[u.entityID], r => r.childCharTypeID != this.relationshipCharTypeID);
                    this.recordChildRelationships[u.entityID] = notRelCharTypeIDRels.concat(recordChildRels);
                }
                else if (this.bulkRecordAssociationMode == BulkAssociationMode.Remove) {
                    var childEntityIDs: string[] = [];
                    _.forEach(this.selectedEntities, (se) => {
                        _.remove(recordChildTitles, r => r.recID == se.recordID);
                        var childRelRec = _.find(recordChildRels, r => r.childRecID == se.recordID);
                        if (childRelRec != undefined) {
                            removeRelationshipIDs.push(Utils.IdBuilder.buildRelationshipID(childRelRec));
                        }
                        _.remove(recordChildRels, r => r.childRecID == se.recordID);
                    });
                }
                else if (this.bulkRecordAssociationMode == BulkAssociationMode.Replace) {
                    var childEntityIDs = _.cloneDeep(recordChildRels.map((e) => { return Utils.IdBuilder.buildEntityID(e.divisionID, Consts.CharTypeIDs.relationship, e.relRecID); }));
                    recordChildRels = [];
                    recordChildTitles = [];

                    _.forEach(this.selectedEntities, (se) => {
                        var fakeRecChilRel: Models.IEntityRelationship = {
                            divisionID: split.divID,
                            parentRecID: 0,
                            parentCharTypeID: 0,
                            childCharTypeID: this.relationshipCharTypeID,
                            childRecID: se.recordID,
                            level: 0,
                            relRecID: 0,
                            relTypeID: 1,
                            relIndicatorID: 0,
                            sequenceNumber: 0
                        };
                        recordChildRels.push(fakeRecChilRel);

                        var recordChildTitle: Models.IEntityRecIDTitle = {
                            recID: se.recordID,
                            title: se.title
                        };
                        recordChildTitles.push(recordChildTitle);
                    });

                    if (this.relationshipTitles[u.entityID] == undefined) {
                        this.relationshipTitles[u.entityID] = {};
                    }

                    this.relationshipTitles[u.entityID][this.relationshipCharTypeID] = recordChildTitles;
                    removeRelationshipIDs = removeRelationshipIDs.concat(childEntityIDs);
                    var notRelCharTypeIDRels = _.filter(this.recordChildRelationships[u.entityID], r => r.childCharTypeID != this.relationshipCharTypeID);
                    this.recordChildRelationships[u.entityID] = notRelCharTypeIDRels.concat(recordChildRels);
                    var recParentRel = _.find(this.recordParentRelationships, r => r.childRecID == split.recID);
                    this.addRelationships[this.relationshipCharTypeID][Utils.IdBuilder.buildRelationshipID(recParentRel)] = this.selectedEntities.map((ae) => { return ae.entityID; });
                }
            });

            this.removeRelationships[this.relationshipCharTypeID] = removeRelationshipIDs;
            this.selectedBulkEditMode = BulkEditMode.Regular;
        }
    }

    public SaveSelectedRelationshipsRecordsForRecord() {
        var parentEntityID = "";
        if (this.charTypeID == Consts.CharTypeIDs.amount) {
            for (let entityID in this.entityRelRecIDs) {
                if (this.entityRelRecIDs[entityID] == this.searchByEntityID) {
                    parentEntityID = entityID;
                }
            }
        }
        else {
            parentEntityID = this.parentEntityID;
        }

        let cdcs = this.groupedEntityCharDataCollections[parentEntityID];

        if (_.any(cdcs, c => c.entityID == this.recRelsEntityID)) {

            if (this.isBulkCreateMode) {

                if (this.relationshipTitles[this.recRelsEntityID] == undefined) {
                    this.relationshipTitles[this.recRelsEntityID] = {};
                }

                this.relationshipTitles[this.recRelsEntityID][this.relationshipCharTypeID] = [];

                var usageRelatedItems: Models.IEntityRecIDTitle[] = [];

                this.selectedEntities.map((ae) => { return ae.entityID; });
                _.forEach(this.selectedEntities, (se) => {
                    var usageRelatedItem: Models.IEntityRecIDTitle = {
                        recID: se.recordID,
                        title: se.title
                    };
                    usageRelatedItems.push(usageRelatedItem);
                });

                this.relationshipTitles[this.recRelsEntityID][this.relationshipCharTypeID] = usageRelatedItems;
            }
            else {
                var split = Utils.IdBuilder.splitEntityID(this.recRelsEntityID);
                var removeRelationshipIDs: string[] = this.removeRelationships[this.relationshipCharTypeID];
                if (removeRelationshipIDs == undefined) {
                    removeRelationshipIDs = [];
                }
                var recordChildRels: Models.IEntityRelationship[];
                if (this.recordChildRelationships[this.recRelsEntityID] == undefined) {
                    recordChildRels = [];
                }
                else {
                    recordChildRels = this.recordChildRelationships[this.recRelsEntityID];
                }

                if (this.relationshipTitles[this.recRelsEntityID] == undefined) {
                    this.relationshipTitles[this.recRelsEntityID] = {};
                }

                this.relationshipTitles[this.recRelsEntityID][this.relationshipCharTypeID] = [];
                var recordChildTitles: Models.IEntityRecIDTitle[] = [];

                _.forEach(this.selectedEntities, (se) => {
                    if (!_.any(recordChildRels, rc => rc.childRecID == se.recordID)) {
                        var fakeRecChilRel: Models.IEntityRelationship = {
                            divisionID: split.divID,
                            parentRecID: 0,
                            parentCharTypeID: 0,
                            childCharTypeID: this.relationshipCharTypeID,
                            childRecID: se.recordID,
                            level: 0,
                            relRecID: 0,
                            relTypeID: 1,
                            relIndicatorID: 0,
                            sequenceNumber: 0
                        };
                        recordChildRels.push(fakeRecChilRel);
                    }
                    var recordChildTitle: Models.IEntityRecIDTitle = {
                        recID: se.recordID,
                        title: se.title
                    };
                    recordChildTitles.push(recordChildTitle);
                });

                this.relationshipTitles[this.recRelsEntityID][this.relationshipCharTypeID] = recordChildTitles;

                var selectedRecordItemIDs = _.map(this.selectedEntities, (s) => { return s.recordID; });
                var removeEntities = _.filter(recordChildRels, (rel) => {
                    return (rel.childCharTypeID == this.relationshipCharTypeID && selectedRecordItemIDs.indexOf(rel.childRecID) <= -1);
                });

                if (removeEntities.length > 0) {
                    var removeRelIDs = removeEntities.map((e) => {
                        return Utils.IdBuilder.buildEntityID(split.divID, Consts.CharTypeIDs.relationship, e.relRecID);
                    });
                    var removeRecIDs = removeEntities.map((e) => {
                        return e.childRecID;
                    });
                    removeRelationshipIDs = removeRelationshipIDs.concat(removeRelIDs);
                    this.removeRelationships[this.relationshipCharTypeID] = removeRelationshipIDs;
                    recordChildRels = _.filter(recordChildRels, (rel) => {
                        return (rel.childCharTypeID == this.relationshipCharTypeID && removeRecIDs.indexOf(rel.childRecID) < 0);
                    });
                    this.recordChildRelationships[this.recRelsEntityID] = recordChildRels;
                }

                var recParentRel = _.find(this.recordParentRelationships, r => r.childRecID == split.recID);
                if (this.addRelationships[this.relationshipCharTypeID] == undefined) {
                    this.addRelationships[this.relationshipCharTypeID] = {};
                }
                this.addRelationships[this.relationshipCharTypeID][Utils.IdBuilder.buildRelationshipID(recParentRel)] = this.selectedEntities.map((ae) => { return ae.entityID; });
            }
        }

        this.selectedBulkEditMode = BulkEditMode.Regular;
    }

    public SetupPagerForPageSize(pageSize: number): void {
        for (let groupEntityID in this.groupedEntityCharDataCollections) {
            this.searchPageSize[groupEntityID] = pageSize;
            this.startPageRecord[groupEntityID] = (this.searchPage[groupEntityID] - 1) * this.searchPageSize[groupEntityID];
            this.endPageRecord[groupEntityID] = this.startPageRecord[groupEntityID] + this.searchPageSize[groupEntityID];
        }
    }

    public SetupPagerForPage(page: number): void {
        for (let groupEntityID in this.groupedEntityCharDataCollections) {
            this.searchPage[groupEntityID] = page;
            this.startPageRecord[groupEntityID] = (this.searchPage[groupEntityID] - 1) * this.searchPageSize[groupEntityID];
            this.endPageRecord[groupEntityID] = this.startPageRecord[groupEntityID] + this.searchPageSize[groupEntityID];
        }
    }

    public isSelectedButtonEnabled(): boolean {
        return this.selectedEntities.length > 0;
    }

    private getRelationshipsRequired(charTypeID: number, templateID: number, childCharTypeID: number) {
        this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(charTypeID, templateID, childCharTypeID)
            .then((res) => {
                if (res && res.charTypeID) {
                    this.relationshipsRequired[childCharTypeID.toString()] = true;
                }
            });
    }
}
